import { themeV2 as theme } from '@features/executive-report/domain/theme-v2';
import { ShapeProps } from '@features/powerpoint';

export const arrowFromValue = (
  value: number,
  layout: Pick<ShapeProps['options'], 'x' | 'y' | 'h' | 'w'>,
  lineWidth?: number
): ShapeProps | null => {
  if (value === 0) return null;

  const lineOptions: ShapeProps['options']['line'] =
    value >= 0
      ? { beginArrowType: 'triangle', color: theme.colors.inmarketGreen }
      : { endArrowType: 'triangle', color: theme.colors.red };

  return {
    shapeName: 'line',
    options: {
      ...layout,
      line: {
        width: lineWidth ?? 5,
        ...lineOptions,
      },
    },
  };
};
